<div class="modal-header">
  <h4 class="modal-title">
    Оценка на {{ dealParticipantType === DealParticipantType.Buyer ? 'продавача' : 'купувача' }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <form [formGroup]="form">
    <p class="mb-2">Изберете в проценти вашата оценка за сключената сделка.</p>
    <ul class="list-unstyled d-flex gap-2">
      @for (rate of feedbackRateOptions; track rate.feedbackRateOptionId) {
        <li class="p-2 border shadow rounded-3 d-flex flex-column align-items-center justify-content-between w-100">
          <label class="d-flex flex-column align-items-center justify-content-between h-100 w-100 cursor-pointer"
                 [for]="'feedbackRate-' + rate.feedbackRateOptionPercentage"
                 [ngClass]="rate.feedbackRateOptionPercentage <= 25 ? 'text-danger'
                    : rate.feedbackRateOptionPercentage === 50 ? 'text-warning' : 'text-success'">
            <input
              type="radio"
              class="form-check-input"
              name="feedbackRateOptionId"
              [value]="rate.feedbackRateOptionId"
              [id]="'feedbackRate-' + rate.feedbackRateOptionPercentage"
              formControlName="feedbackRateOptionId">
            <span class="pt-1 fw-bold">{{ rate.feedbackRateOptionPercentage }}%</span>
          </label>
        </li>
      }
    </ul>
    @if (feedbackRateOptionId?.touched && feedbackRateOptionId?.invalid) {
      <div class="text-danger">
        Задължително е избирането на една от стойностите!
      </div>
    }
    @if (filteredFeedbackCommentOptions.length !== 0) {
      <div class="mb-2">
        Изберете коментар или добавете собствен.
      </div>
      <ul class="list-unstyled">
        @for (comment of filteredFeedbackCommentOptions; track comment.feedbackCommentOptionId) {
          <li>
            <div class="form-check mb-2">
              <input
                type="radio"
                class="form-check-input"
                name="feedbackCommentOptionId"
                [value]="comment.feedbackCommentOptionId"
                [id]="'feedbackComment-' + comment.feedbackCommentOptionId"
                formControlName="feedbackCommentOptionId">
              <label class="form-check-label"
                     [for]="'feedbackComment-' + comment.feedbackCommentOptionId">
                {{ comment.feedbackCommentOptionComment }}
              </label>
            </div>
          </li>
        }
      </ul>
      @if (feedbackCommentOptionId?.touched && feedbackCommentOptionId?.invalid) {
        <p class="text-danger">
          Задължително е избирането на коментар или добавянето на собствен!
        </p>
      }
      <div class="form-floating">
        <textarea
          class="form-control"
          placeholder="Leave a comment here"
          id="floatingTextarea2"
          rows="6"
          formControlName="customComment"
          style="height: 100px">
        </textarea>
        <label for="floatingTextarea2">Собствен коментар</label>
      </div>
      @if (customComment?.touched && customComment?.invalid) {
        <p class="text-danger">
          Задължително е добавянето на коментар!
        </p>
      }
    }
  </form>
  @if (!!errorMessage) {
    <div class="mt-3 text-danger">
      {{ errorMessage }}
    </div>
  }
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loadingData || loadingSubmit"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loadingSubmit) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
